import { cn } from "@/lib/utils";

import { SELECT_CLASS } from "../constants";

interface Props {
  label: string;
  value: string;
  options: Array<{ value: string; label: string }>;
  onChange: (value: string) => void;
  // Text of the empty option that clears the filter; omitted when a value is required.
  allLabel?: string;
  className?: string;
}

export const FilterSelect = ({ label, value, options, onChange, allLabel, className }: Props) => (
  <select
    className={cn(SELECT_CLASS, className)}
    aria-label={label}
    value={value}
    onChange={event => onChange(event.target.value)}
  >
    {allLabel !== undefined ? <option value="">{allLabel}</option> : null}
    {options.map(option => (
      <option key={option.value} value={option.value}>
        {option.label}
      </option>
    ))}
  </select>
);
